import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import { memo, useCallback } from 'react';
import { DEFAULT_CREDIT_TABS } from '../../../Blotters/Credit/defaults';
import { CREDIT_BLOTTER_PREFIX } from '../../../Blotters/Credit/tokens';
import type { CreditTabProps } from '../../../Blotters/Credit/types';
import { MobileFilteredCredit } from './Credit/MobileFilteredCredit';
import {
  MobileBlotterPanel,
  type MobileBlotterPanelProps,
  type MobileBlotterPanelRenderTabArgs,
} from './MobileBlotterPanel';

/**
 * Mobile credit panel. `blotterID` uses the same `credits-v2/<tabId>` convention
 * as desktop so persisted layout / filter state is shared.
 */
export const MobileCreditBlotter = memo(function MobileCreditBlotter(
  props: Omit<MobileBlotterPanelProps<CreditTabProps>, 'defaultTabs' | 'renderTab'>
) {
  const renderTab = useCallback(
    ({ tab, tabId, updateTab }: MobileBlotterPanelRenderTabArgs<CreditTabProps>) => (
      <MobileFilteredCredit
        key={tabId}
        blotterID={`${CREDIT_BLOTTER_PREFIX}/${tabId}`}
        tab={tab as CreditTabProps}
        onUpdateTab={updatedTab => updateTab(updatedTab)}
      />
    ),
    []
  );

  return (
    <MixpanelSourceProvider value={MixpanelEventSource.CreditBlotter}>
      <MobileBlotterPanel<CreditTabProps> {...props} defaultTabs={DEFAULT_CREDIT_TABS} renderTab={renderTab} />
    </MixpanelSourceProvider>
  );
});
